/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_CrumbInputs */

const en_newsletter_archive_crumb = /** @type {(inputs: Newsletter_Archive_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter`)
};

/**
* | output |
* | --- |
* | "Newsletter" |
*
* @param {Newsletter_Archive_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_crumb = /** @type {((inputs?: Newsletter_Archive_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_crumb(inputs)
});